import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import { useGetDisplayOptionsClasses } from '~/composables/useGetDisplayOptionsClasses';
import BlockExpandableTabStandard from '~/components/cms/custom/BlockExpandableTab/BlockExpandableTabStandard.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'BlockExpandableTab',
  props: {
    title: null,
    displayOptions: {
      default: function _default() {
        return [];
      }
    },
    catchphrase: null,
    image: null,
    inTabContainer: {
      type: Boolean
    },
    tabIndex: null,
    currentActiveTab: null,
    currentClassName: null,
    contents: {
      default: function _default() {
        return [];
      }
    },
    isInsideBlockList: {
      type: Boolean
    },
    isLast: {
      type: Boolean
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var BlockExpandableTabInContainer = function BlockExpandableTabInContainer() {
      return import('~/components/cms/custom/BlockExpandableTab/BlockExpandableTabInContainer.vue');
    };
    var componentName = props.inTabContainer ? BlockExpandableTabInContainer : BlockExpandableTabStandard;
    var classes = useGetDisplayOptionsClasses(props.displayOptions);
    var showSeparator = computed(function () {
      return props.isInsideBlockList;
    });
    return {
      __sfc: true,
      BlockExpandableTabInContainer: BlockExpandableTabInContainer,
      props: props,
      componentName: componentName,
      classes: classes,
      showSeparator: showSeparator
    };
  }
});